import { createEntityAdapter } from "@ngrx/entity";
import { VerifiedPrice } from "entities/parts/verified-price";

export const verifiedPricesAdapter = createEntityAdapter<VerifiedPrice>({
    selectId: (verifiedPrice) => verifiedPrice.partNumber
});
